<template>
  <div class="filter-check-box-group">
    <a-checkbox-group class="checkGroup" @change="onChange" v-model="currentSelected">
      <component
      :is="componentGroup"
      v-bind="$attrs"
      v-on="$listeners"
      :instance="instance"
      @sliderUpdate="handlerSliderUpdate"
      @clearSelected="handlerClearSelected"></component>
    </a-checkbox-group>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import PureCheckBox from './pureCheckBox.vue'
import IpcGroup from './IpcGroup.vue'
import SliderGroup from './SliderGroup.vue'

export default {
  props: {
    instance: Object,
    groupType: String // 动态组件类型
  },
  data() {
    return {
      currentSelected: [], // 当前选中
      componentGroup: '' // 默认使用纯净版
    }
  },
  components: {
    PureCheckBox,
    IpcGroup,
    SliderGroup
  },
  created() {
    this.gatherChecked() // 收集当前选中的值设为默认展示
    this.componentGroup = this.groupType || 'PureCheckBox'
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateTempFilterItem',
      'deleteTempFilterItem'
    ]),
    handlerClearSelected(label) {
      this.clearSelected()
      this.deleteTempFilterItem(label) // 删除
    },
    clearSelected() {
      this.currentSelected = []
    },
    gatherChecked() {
      const disabledMAP = ['SliderGroup']
      const {
        list, key, currentIndex, componentGroup
      } = this.instance
      if (disabledMAP.includes(componentGroup)) return
      const k = typeof key === 'object' ? key[currentIndex] : key
      this.currentSelected = list.reduce((pre, cur) => {
        if (cur.checked) {
          pre.push(cur[k])
        }
        return pre
      }, [])
    },
    // 更新滑块的值
    handlerSliderUpdate(params) {
      const { item, value } = params
      this.$set(item, 'defaultValue', value)
    },
    onChange(v) {
      const params = this.handlerParams(v)
      this.updateTempFilterItem(params) // 通过vuex更新
      // this.$emit('filterItemChange', hasDealParams)
    },
    handlerParams(v) {
      const {
        name, currentIndex, key, labelPrefix, tabsList, isTabsGroup
      } = this.instance
      const isObj = typeof name === 'object'
      const label = isObj ? name[currentIndex] : name
      const selectedValue = v.map((item) => `"${item}"`)
      let expName = label
      if (labelPrefix && isTabsGroup) { // 处理tabs类型 并且需要添加前缀
        const name = tabsList.find((item) => item.value === key).label || ''
        expName = `${labelPrefix}${name}`
      }
      return {
        label,
        expName,
        key: isObj ? key[currentIndex] : key,
        selectedValue
      }
    }
  }
}
</script>
